import React from 'react';
import { IoClose, IoMenuOutline } from 'react-icons/io5';
import LandEvaluation from './land-evaluation/LandEvaluation';
import ResearchToolTab from './atlas/research/ResearchToolTab';
import './ToolPanel.css';

const TOOL_NAMES = {
  research: 'Live Web Research',
  land: 'Land Evaluation',
};

const TOOL_SUBTITLES = {
  land: 'Property, deeds, schools, demographics, market, economy and jobs for any US address',
};

const ToolPanel = ({
  user,
  selectedTool,
  onClose,
  onDiscussWithAtlas,
  isMobile = false,
  onMenuClick,
}) => {
  const renderToolContent = () => {
    switch (selectedTool) {
      case 'research':
        return <ResearchToolTab />;
      case 'land':
        return <LandEvaluation user={user} onDiscussWithAtlas={onDiscussWithAtlas} />;
      default:
        return (
          <div className="tool-panel-empty">
            <p>Select a tool from the sidebar</p>
          </div>
        );
    }
  };

  return (
    <div className={`tool-panel tool-panel-${selectedTool || 'none'}`}>
      <div className="tool-panel-header">
        <div className="tool-panel-header-left">
          {isMobile && onMenuClick ? (
            // A tool replaces the chat (and its menu button) on mobile; reopen the drawer from here.
            <button type="button" className="tool-panel-menu-btn" onClick={onMenuClick} aria-label="Open menu">
              <IoMenuOutline size={24} />
            </button>
          ) : null}
          <div className="tool-panel-heading">
            <h2 className="tool-panel-title">{TOOL_NAMES[selectedTool] || 'Tool'}</h2>
            {TOOL_SUBTITLES[selectedTool] ? (
              <p className="tool-panel-subtitle">{TOOL_SUBTITLES[selectedTool]}</p>
            ) : null}
          </div>
        </div>

        <div className="tool-panel-controls">
          <button
            type="button"
            className="tool-panel-close"
            onClick={onClose}
            title="Close tool"
            aria-label="Close tool"
          >
            <IoClose size={20} />
          </button>
        </div>
      </div>

      <div className="tool-panel-body">
        {renderToolContent()}
      </div>
    </div>
  );
};

export default ToolPanel;
